import {Directive,ElementRef,inject} from '@angular/core';
import {NgControl} from '@angular/forms';

@Directive({
	selector:'[appInputEmptyToNull]',
	host:{
		'(input)':'onEvent($event)',
		'(blur)':'onEvent2($event)'
	}
})
export class InputEmptyToNullDirective{
	private elementRef=inject(ElementRef);
	private ngControl=inject(NgControl);

	onEvent(event:Event):void{
		this.putValue(event.target as HTMLInputElement);
	}

	onEvent2(event:Event):void{
		this.putValue(event.target as HTMLInputElement);
	}

	putValue(target:HTMLInputElement):void{
		this.ngControl!.control!.setValue((target.value==='') ? null : target.value);
	}
}
